/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
// import { Dropdown } from "../reuseable";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import useLanguage from "../common_hooks/useLanguage";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import tipe_1_string_array from "../../Data/tipe_1_string_array.json";

/*CONST*/

const SET_CP = ({
  //variable
  properties,

  //function
  set_value_properties,
}) => {
  //localStorage
  const { language, dict } = useLanguage();

  //state & ref

  //global props
  const { field_editable } = properties;
  const { poi_type, poi_rad } = field_editable || {};

  //variables


  //functions
  const on_change = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    set_value_properties({
      key: "field_editable",
      value: {
        ...field_editable,
        [name]: value,
      },
    });
  };

  return (
    <main>
      <h1 className="text_bold margin_bottom">Pengaturan Counting POI</h1>

      <div
        className="container background_grey_light outline_grey"
        style={{ marginBottom: "15px" }}
      >
        <p className="text_bold">
          {
            dict?.[
            "Select the POI category to count the number of POIs."
            ]?.[language]
          }
        </p>
        <select
          id="poi_type"
          name="poi_type"
          value={poi_type}
          onChange={on_change}
        >
          <option value="">
            {dict?.["Select a point of interest theme"]?.[language]}
          </option>
          {tipe_1_string_array.map((item, idx) => {
            return (
              <option key={idx} value={item}>
                {item}
              </option>
            );
          })}
        </select>
        <p className="text_bold">
          {dict?.["Set POI radius from surveyor point (km)"]?.[language]}
        </p>
        <input
          id="poi_rad"
          name="poi_rad"
          value={poi_rad}
          type="number"
          onChange={on_change}
          className="full_width"
        />
        {poi_rad < 1 && (
          <section>
            {poi_rad} km = {poi_rad * 1000} meter
          </section>
        )}
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  // auth: state.auth,
  // layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties })(SET_CP);
